import {UyapRequest} from "./UyapRequest";
import app from "@/main";
import {ISorguSonuc} from "./CommonInterfaces";

export interface KamuEmekliTalep {
    dosyaId: string,
    kisiKurumId: number,
}

export interface KamuEmekliCevap extends ISorguSonuc<IKamuEmekliSonuc>{}

// DEV-3514: başarılı cevabın şekli henüz bilinmiyor (HAR yok; yalnız 990 "Kayıt Bulunamadı." görüldü).
// Kayıtları doğrudan değil kamuEmekliKayitlari() ile okuyun.
export interface IKamuEmekliSonuc {
    emekliKaydi4AList?: Array<any>,
    emekliKaydi4a?: Array<any>,
    hataKodu: 0 | 990 | number,      // başarılı | kayıt bulunamadı
    hataMesaji: string | null,
    [alan: string]: any
}

// Kayıt sayılmayan, her DVO'da gelen alanlar.
export const KAMU_EMEKLI_KAYIT_DISI_ALANLAR = ["hataKodu", "hataMesaji", "isNew"];

function nesneDizisiMi(deger: any): boolean {
    return Array.isArray(deger) && deger.some(kayit => kayit && typeof kayit === "object");
}

// DEV-3514: kayıtlar önce bilinen liste alanlarında, yoksa DVO'daki (ya da bir alt nesnesindeki) ilk nesne
// dizisinde aranır. Hiç dizi yoksa başarılı cevapta DVO'nun kendisi tek kayıt sayılır (SgkKamu gibi düz gelebilir).
export function kamuEmekliKayitlari(sonuc?: Partial<IKamuEmekliSonuc> | string | null): Array<Record<string, any>> {
    if (!sonuc || typeof sonuc !== "object")
        return [];
    // DEV-3514: bilinen listede de yalnız nesneler kayıttır; null eleman KamuEmekliDetay'ı çökertiyordu.
    for (const alan of ["emekliKaydi4AList", "emekliKaydi4a"]) {
        if (Array.isArray(sonuc[alan]))
            return sonuc[alan].filter((kayit: any) => kayit && typeof kayit === "object");
    }
    const degerler = Object.values(sonuc);
    const altDegerler = degerler
        .filter(deger => deger && typeof deger === "object" && !Array.isArray(deger))
        .flatMap(deger => Object.values(deger));
    const liste = [...degerler, ...altDegerler].find(nesneDizisiMi);
    if (liste)
        return liste.filter((kayit: any) => kayit && typeof kayit === "object");
    const alanlar = Object.keys(sonuc).filter(alan => !KAMU_EMEKLI_KAYIT_DISI_ALANLAR.includes(alan));
    return sonuc.hataKodu == 0 && alanlar.length > 0 ? [sonuc] : [];
}


export default class KamuEmekli extends UyapRequest<KamuEmekliTalep, KamuEmekliCevap> {
    getMethod(): 'GET' | 'POST' {
        return 'POST';
    }

    getSpinnerMessage(){
        return "Kamu emekli bilgileri sorgulanıyor...";
    }

    cache() {
        return {
            active: true,
            ttl: (60 * 24), //* 1 gun
            key: "KamuEmekli_" + app.$uyapHelper.hash(this.talepData)
        };
    }

    getMockResponse(): any {
        return {"borcluBilgileri":{"kisiTumDVO":{"olumKaydi":false,"isAvukat":false,"isGecerlilikAktifAvukat":false,"isNoter":false,"isTarafUyari":false,"isHakimSavci":false,"mernisDegisiklikVarmi":false,"mernisDegisiklikNedeni":"","sorguTuru":0,"tcKimlikNo":"4********10","adi":"AH**** MÜ***","soyadi":"YA*******","babaAdi":"A*********","anaAdi":"Ş*****","dogumTarihiStr":"1957","aktifMernisAdresiSorgusu":true,"hasOlumKaydi":false},"kisiKurumId":28698317,"turu":0},"sorgulayanBilgileri":"Av.NİHAN ERDOĞAN","portalTuru":2,"dosyaOzetDVO":{"birimDVO":{"birimAdi":"Ankara 2. Genel İcra Dairesi","birimId":"1000963","orgKodu":"1.04.011.000.6037","duzey1":"1","duzey2":"04","duzey3":"011","duzey4":"000","duzey5":"6037","birimTuru1":"11","birimTuru2":"1101","birimTuru3":"1199","evraginBirimDVODaGonderilecegiBirimBilgisi":0,"yeniBirimEkle":true,"orgKoduDegisti":false,"isTumunuKopyala":false,"eskiAd":"","eskiOrgKod":"","taranmamisKaydetme":"","testMi":0},"rolIdList":[],"isBirimKapali":false,"dosyaTurKod":35,"dosyaTurAd":"İcra Dosyası","dosyaNo":"2023/27440","dosyaNoYil":2023,"dosyaSira":27440,"dosyaId":"013@RlwAzAkR3QHUdOJ2IhIOb@zlliUh@v9RfAR0ZEv2WhKJdYOPrlnR0EJe3BRS","dosyaAcilisTarihi":"08/07/2023 10:35","genelDosyaDurumu":"Açık","genelDosyaDurumuAsInteger":0,"taraflar":"ABDULSELAM DENİZ, AHMETİ MÜNÜR YALÇINALP","vekilId":0,"vekilMi":false,"vekilHazineAvukatiMi":false},"sorguTarihi":"26/07/2024 14:46","sorguSonucDVO":{"hataKodu":990,"hataMesaji":"Kayıt Bulunamadı."},"sorgulamaTuru":"Kamu Emeklisi","sorguSonucu":true,"hasError":false,"hasData":false,"isMock":false};
    }

    getUrl(): string {
        return this.ImzaClientAddr + 'borclu_bilgileri_goruntule_sgk_kamuEmekliBilgileri.ajx';
    }

    async parse(data: any): Promise<KamuEmekliCevap> {
        // DEV-3354 (DEV-2233 kalıbı): kayıt yoksa sorguSonucDVO hiç dönmüyor,
        // kimlik bilgisi eksikse düz hata metni geliyor.
        const sonuc = data.sorguSonucDVO;
        if (typeof sonuc === "string" && sonuc) {
            data.message = sonuc;
            data.sorguSonucu = false;
        } else if (!sonuc || sonuc.hataKodu != 0) {
            data.message = sonuc?.hataMesaji || "Kayıt bulunamadı";
            data.sorguSonucu = false;
        } else
            data.message =  "SGK Kamu Emekli bilgisi var";
        return data;
    }

}